export function generateRandomUUID() {
  return crypto.randomUUID()
}
